import _ from 'lodash'
import CustomAction from './lib/CustomAction'
import services from './services'
import utilities from './utilities'

const mutations = {
  entity (state, { stateKey, data }) {
    state[stateKey].entity = data
  },

  entities (state, { stateKey, data }) {
    state[stateKey].all = data
    state[stateKey].entities = data
  },

  error (state, { data, message, stateKey }) {
    state[stateKey].error = message || ''
    state[stateKey].errors = data || []
  },

  errorOnAll (state, { error, stateKey }) {
    state[stateKey].errorOnAll = error || undefined
  },

  errorOnCreate (state, { error, stateKey }) {
    state[stateKey].errorOnCreate = error || undefined
  },

  errorOnFind (state, { error, stateKey }) {
    state[stateKey].errorOnFind = error || undefined
  },

  errorOnGet (state, { error, stateKey }) {
    state[stateKey].errorOnGet = error || undefined
  },

  errorOnList (state, { error, stateKey }) {
    state[stateKey].errorOnList = error || undefined
  },

  errorOnRemove (state, { error, stateKey }) {
    state[stateKey].errorOnRemove = error || undefined
  },

  errorOnSave (state, { error, stateKey }) {
    state[stateKey].errorOnSave = error || undefined
  },

  errorOnUpdate (state, { error, stateKey }) {
    state[stateKey].errorOnUpdate = error || undefined
  },

  isAllPending (state, { pending, stateKey }) {
    state[stateKey].isAllPending = pending
  },

  isCreatePending (state, { pending, stateKey }) {
    state[stateKey].isCreatePending = pending
  },

  isFindPending (state, { pending, stateKey }) {
    state[stateKey].isFindPending = pending
  },

  isGetPending (state, { pending, stateKey }) {
    state[stateKey].isGetPending = pending
  },

  isListPending (state, { pending, stateKey }) {
    state[stateKey].isListPending = pending
  },

  isRemovePending (state, { pending, stateKey }) {
    state[stateKey].isRemovePending = pending
  },

  isSavePending (state, { pending, stateKey }) {
    state[stateKey].isSavePending = pending
  },

  isUpdatePending (state, { pending, stateKey }) {
    state[stateKey].isUpdatePending = pending
  },

  list (state, { stateKey, data }) {
    const {
      page, pageSize, rows, total, totalPages
    } = data

    _.assign(state[stateKey], {
      page, pageSize, rows, total, totalPages
    })
  },

  removed (state, { stateKey, data }) {
    state[stateKey].removed = data;

    ['all', 'entities', 'rows'].forEach(key => {
      state[stateKey][key].map(({ _id }, index) => {
        if (_id === data._id) {
          state[stateKey][key].splice(index, 1)
        }
      })
    })
  }
}

services.forEach(service => {
  service.customActions.forEach(opts => {
    const CA = new CustomAction(opts)
    const stateKey = _.camelCase(service.name)

    mutations[`${service.name}/errorOn${CA.getMutationStatusFormat()}`] = (state, error) => {
      state[stateKey][`errorOn${CA.getMutationStatusFormat()}`] = error.message
    }

    mutations[`${service.name}/is${CA.getMutationStatusFormat()}Pending`] = (state, status) => {
      state[stateKey][`is${CA.getMutationStatusFormat()}Pending`] = status
    }

    mutations[`${service.name}/${CA.getMutationFormat()}`] = (state, entity) => {
      state[stateKey][CA.getMutationFormat()] = entity
    }
  })
})

utilities.mergeMutationExtensions(mutations)

export default mutations
